import React from 'react';
import clsx from 'clsx';

import ThreeDotMenu from '../../../../../../../../common/ThreeDotMenu/ThreeDotMenu';
import { formatDateByFormat, DATE_FORMATS } from '../../../../../../../../utils/dateUtils';
import { KEYBOARD_EVENTS } from '../../../../../../../../utils/constants/commonConstants';

import { FILE_TYPE_ICONS, DEFAULT_FILE_ICON } from './FileAttachmentCard.constants';
import { FileAttachmentCardProps } from './FileAttachmentCard.types';

import styles from './FileAttachmentCard.module.scss';

const FileAttachmentCard: React.FC<FileAttachmentCardProps> = ({
    fileUrl,
    fileName,
    fileType,
    createdAt,
    onDownload,
    className,
    truncateName = true,
    onCardClick,
}) => {
    const ext = (fileType || fileName.split('.').pop() || '').toLowerCase();
    const icon = FILE_TYPE_ICONS[ext] || DEFAULT_FILE_ICON;
    const formattedTimestamp = formatDateByFormat(createdAt, DATE_FORMATS.LIBRARY_FILE_TIMESTAMP);

    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (!onCardClick) return;
        // Space (' ') has no KEYBOARD_EVENTS constant; it is kept literal so the
        // role="button" card activates on both Enter and Space per a11y convention.
        if (event.key === KEYBOARD_EVENTS.ENTER || event.key === ' ') {
            event.preventDefault();
            onCardClick();
        }
    };

    return (
        <div
            className={clsx(styles.FileAttachmentCard, !truncateName && styles.FullName, onCardClick && styles.Clickable, className)}
            {...(onCardClick && { role: 'button', tabIndex: 0, onClick: onCardClick, onKeyDown: handleKeyDown })}
        >
            <img className={styles.FileIcon} src={icon} alt={ext || 'file'} />
            <div className={styles.FileInfo}>
                <div className={styles.FileName} title={fileName}>
                    {fileName}
                </div>
                {formattedTimestamp && <div className={styles.FileTimestamp}>{formattedTimestamp}</div>}
            </div>
            <div className={styles.FileMenuWrapper} onClick={(event) => event.stopPropagation()}>
                <ThreeDotMenu
                    size="small"
                    menuItems={[
                        {
                            name: 'Download',
                            onClick: () => onDownload(fileUrl, fileName),
                        },
                    ]}
                />
            </div>
        </div>
    );
};

export default FileAttachmentCard;
